import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { faqs } from '../../data/faqs';

const FAQSection = () => (
  <Box component="section" id="faq" sx={{ py: { xs: 8, md: 10 }, backgroundColor: 'background.paper' }}>
    <Container>
      <Typography variant="overline" color="secondary">
        FAQ / Resources
      </Typography>
      <Typography variant="h2" sx={{ mt: 1, color: 'primary.main' }}>
        Frequently asked questions
      </Typography>
      <Typography variant="body1" sx={{ mt: 2, maxWidth: 760 }}>
        Clear answers for owners, construction managers, and procurement teams evaluating ANR Mechanical.
      </Typography>
      <Box sx={{ mt: 4 }}>
        {faqs.map((faq) => (
          <Accordion key={faq.question} disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  </Box>
);

export default FAQSection;
